import { gql } from "@apollo/client";

export const UPDATE_ALIMENTACION_PARENTERAL = gql`
    mutation CreateAndUpdateAlimentacionParenteralRI(
        $screen: Int!
        $input: AddAlimentacionParenteralRIInput!)
    {
        createAndUpdateAlimentacionParenteralRI(
            screen: $screen
            input: $input
        ){
            idAlimentacionParenteralRI
        }
    }
`;